<template>
    <div style="overflow-x:auto">
        <p-timeline v-if="enable" :value="events" align="bottom" layout="horizontal" class="p-col-12">
            <template #marker="slotProps">
            <span class="time-event" :style="{ background: getBg(slotProps.item) }">
                <i class="pi" :class="getIcon(slotProps.item)"></i>
            </span>
            </template>
            <template #content="slotProps">  
                <div class="card-content">
                    <p><span v-if="slotProps.item.dud">Awaiting </span>{{ slotProps.item.input_event ? "Data Update" : "Review"  }} Event</p>
                    <p><span v-if="slotProps.item.dud">by </span> Role: {{ slotProps.item.role?.split(",")[0]  }}<br/>
                        <span v-if="slotProps.item.username?.length">Username: {{ slotProps.item.username  }}</span><br/>
                        <span v-if="slotProps.item.date">Date: {{ (new Date(slotProps.item.date)).toLocaleString("en-IN")   }}</span>
                    </p>
                    
                    <small v-if="slotProps.item.dud"></small>
                    <small v-else-if="slotProps.item.approve">Approved</small>
                    <small v-else-if="slotProps.item.rejected">Rejected</small>
                    <small v-else-if="!slotProps.item.input_event">Need information</small>
                </div>
            </template>
        </p-timeline> 
    </div>
  </template>
  
  <script lang="ts">
  import { base } from "@/misc/base";
  import { Options } from "vue-class-component";
  
  @Options({
    props: {
      id: String,
      resource: String,
    },
  })
  export default class LoanReview extends base {
    id!: any;
    resource!: any
    events : any[] = []
    enable = false

    getBg(item: any){

        if(item.dud)
            return "gray"

        if(item.approve)
            return "green"

        if(item.rejected)
            return "red"

        return "#3E78BC"
    }

    getIcon(item: any){

        if(item.rejected){
            return "pi-times-circle"
        }

        if(item.approve)
            return  'pi-check-circle'

        if(item.remarks?.length){
            return "pi-bell"
        }

        return 'pi-pencil' 
    }

    mounted() {
      const service = this.store.state.simforce
    
        service.get(
            `/signature/${this.id}`,
        ).then(res => {
          this.events = res.data.filter(
            (el:any) => !el.stale && !el.deviation_id
          )

          this.events.sort((a, b ) => (new Date(a.date)).getTime() - (new Date(b.date)).getTime() )
          
          service.
          get(
            `/approve/get_model/${this.resource}`,
          )
          .then((authModel : any) => {

              let model = authModel.data

              if(!this.events.length){
                  this.events.push({
                      input_event : true,
                      dud: true,
                      role : model.maker_allowed?.join(",")
                  })
                  
              }

              if(!model.multi_role_required){
                return
              }

              this.enable = true

              let evSize = this.events.length - 1

              for(let i = 0; i < model.checker_allowed.length;i++){

                  if (i < evSize )
                      continue

                  this.events.push({
                      dud: true,
                      approve: true,
                      role : model.checker_allowed[i]
                  })

              }

          })
          .catch((e : any) => {
             this.handleError(e)
          })
      }).catch( err => {
          console.log(err)
      })
    }

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  p,small {
      text-align:left;
      margin:0;
      text-transform: uppercase;
  }

  small {
      float:left;
      color:#333 !important;
  }

  .pi {
      font-size: 18px;
      position: relative;
      left: 9px;
      top: 8px;
  }

  .time-event {
      background: rgb(62, 120, 188);
      width: 35px;
      height: 35px;
      border-radius: 50%;
      color: #fff;
  }

  p {
      min-width:140px;
  }

  .card-content {
      position: relative;
      left: 24px;
      height: 95px;
      display: flex;
      flex-wrap: wrap;
      width:285px;
  }

  .card-content p, .card-content small {
      align-self:flex-end;
  }

  .card-content small {
      background: #fff;
      position: relative;
      left: 15px;
  }
</style>
  